import SearchSelectionInput from './FormSearchSelectionInput';
import { FormSearchSelectionInputProps } from './types';

export type { FormSearchSelectionInputProps };
export default SearchSelectionInput;
